module.exports = __webpack_public_path__ + "static/media/gluteos.820d83e2.svg";